import {
    fetchAutoLoaderDeviceDetails,
    setAutoLoaderDeviceDetails,
    updateAutoLoaderDeviceDetails,
    deleteAutoLoaderDeviceDetails, updateAutoLoaderDeviceMac,
    updateAutoLoaderMonitoringDetails,
    updateAutoLoaderConfiguration
} from "../network/AutoLoaderDeviceNetworkAPI";
import {getTimestampNow} from "../../../util/Util";

export const AutoLoaderDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            fetchAutoLoaderDeviceDetails(action.data.dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_DEVICE_DATA":
            setAutoLoaderDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAutoLoaderDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_MAC":
            updateAutoLoaderDeviceMac(action.data.dispatcher, action.data.stateValues, action.data.mac,
                action.data.showCustomAlert)
            return state
        case "UPDATE_MONITORING_DATA":
            updateAutoLoaderMonitoringDetails(action.data.dispatcher, action.data.stateValues,
                action.data.mac)
            return state
        case "DELETE_DEVICE_DATA":
            deleteAutoLoaderDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "UPDATE_AUTOLOADER_CONFIGURATION":
            updateAutoLoaderConfiguration(action.data.dispatcher, action.data.configurations,
                action.data.mac,  action.data.showCustomAlert)
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/reducer/AutoLoaderDeviceOverviewReducer.js